// Языки лендинга — те же, что в игре (src/utils/locales.ts), 2026-10-24. Тексты — src/locales/<язык>.ts, образец — en.ts.
import { en, type LandingStrings } from './locales/en';
import { ru } from './locales/ru';
import { es } from './locales/es';
import { de } from './locales/de';
import { fr } from './locales/fr';
import { nl } from './locales/nl';
import { it } from './locales/it';
import { ptBR } from './locales/pt-BR';
import { pl } from './locales/pl';
import { ja } from './locales/ja';
import { ko } from './locales/ko';
import { zhHant } from './locales/zh-Hant';
import { tr } from './locales/tr';

export const LANGS = ['en', 'ru', 'es', 'de', 'fr', 'nl', 'it', 'pt-BR', 'pl', 'ja', 'ko', 'zh-Hant', 'tr'] as const;
export type Language = typeof LANGS[number];

export const STRINGS: Record<Language, LandingStrings> = {
  en, ru, es, de, fr, nl, it, 'pt-BR': ptBR, pl, ja, ko, 'zh-Hant': zhHant, tr,
};

/** Название языка в переключателе — на нём самом. */
export const LANG_NAMES: Record<Language, string> = {
  en: 'English', ru: 'Русский', es: 'Español', de: 'Deutsch', fr: 'Français', nl: 'Nederlands', it: 'Italiano',
  'pt-BR': 'Português (Brasil)', pl: 'Polski', ja: '日本語', ko: '한국어', 'zh-Hant': '繁體中文', tr: 'Türkçe',
};

/** Для дат (Intl) и Apple-ссылок. */
export const LOCALE_TAGS: Record<Language, string> = {
  en: 'en-US', ru: 'ru-RU', es: 'es-ES', de: 'de-DE', fr: 'fr-FR', nl: 'nl-NL', it: 'it-IT',
  'pt-BR': 'pt-BR', pl: 'pl-PL', ja: 'ja-JP', ko: 'ko-KR', 'zh-Hant': 'zh-TW', tr: 'tr-TR',
};

export const isLanguage = (value: string | null | undefined): value is Language =>
  (LANGS as readonly string[]).includes(value ?? '');

/** Как в игре (normalizeLanguage): pt-* → pt-BR; традиционный китайский — zh-Hant / TW / HK / MO, остальной zh → английский. */
export function normalizeLanguage(value?: string | null): Language {
  const tag = value?.replace('_', '-').toLowerCase() ?? '';
  if (tag === 'pt' || tag.startsWith('pt-')) return 'pt-BR';
  if (/^zh-(?:hant|tw|hk|mo)(?:-|$)/.test(tag)) return 'zh-Hant';
  return LANGS.find((lang) => tag === lang.toLowerCase() || tag.startsWith(`${lang.toLowerCase()}-`)) ?? 'en';
}

/** Политика и условия написаны на английском, русском и испанском; на остальных языках показываем английский текст. */
export const LEGAL_LANGS = ['en', 'ru', 'es'] as const;
export type LegalLanguage = typeof LEGAL_LANGS[number];
export const legalLanguage = (lang: Language): LegalLanguage =>
  (LEGAL_LANGS as readonly string[]).includes(lang) ? (lang as LegalLanguage) : 'en';

export const fill = (template: string, values: Record<string, string | number>): string =>
  template.replace(/\{(\w+)\}/g, (m, k: string) => (k in values ? String(values[k]) : m));
